export var MessageType;
(function (MessageType) {
    MessageType["Agent"] = "Agent";
    MessageType["User"] = "User";
    MessageType["System"] = "System";
    MessageType["Task"] = "Task";
    MessageType["Hidden"] = "Hidden";
})(MessageType || (MessageType = {}));
//# sourceMappingURL=message-type.const.js.map